import { get } from '@/common/request';

export function GetSEO() {
  return get('seo_meta/get');
}
